import { Dialog } from '@cmsgov/ds-medicare-gov';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../../common/components/button';
import { modalImpression } from '../analytics';
import capitalizeFirstLetter from '../functions/capitalizeFirstLetter';
import translate from '../functions/translate';
import StackingButtons from './StackingButtons';

interface PopupProps {
    showModal: boolean
}

const Popup = ({ showModal }: PopupProps) => {
    const history = useHistory();
    let location = useLocation();
    let path: string;
    const routeName = location.pathname;
    const route = routeName.substring(routeName.indexOf('/') + 1);
    const pathName = route.endsWith('/') ? route.slice(0, -1) : route;

    const headerText = translate('your_session_timeout');

    useEffect(() => {
        if(showModal){
            modalImpression(headerText);
        }
    }, [showModal, headerText]);

    // match the translations we already have
    switch (pathName) {
        case 'forgot-password':
            path = translate('reset_password');
            break;
        case 'forgot-username':
            path = translate('get_username');
            break;
        case 'create-account':
            path = translate('create_account');
            break;
        case 'login':
            path = translate('log_in_upper');
            break;
        case 'find-my-account':
            path = translate('find_my_account');
            break;
        default:
            path = '';
    }

    const cancelButton = <>
        <Button
            variation={'ghost'}
            onClick={() => document.location.href = '/'}
        >
            {translate('cancel')}
        </Button>
    </>;

    const restartButton = <>
        <Button
            variation={'solid'}
            mfaAnalyticsData={{
                text: translate('ok'),
                parentComponentHeading: ''
            }}
            onClick={() => history.push(routeName)}
        >
            {`${translate('restart')} ${capitalizeFirstLetter(path)}`}
        </Button>
    </>;

    return (
        <div>
            {showModal &&
                <Dialog heading={headerText}>
                    {`${translate('please_restart')} ${capitalizeFirstLetter(path)}`}
                    <StackingButtons
                        button1={restartButton}
                        button2={cancelButton}
                    />
                </Dialog>
            }
        </div>
    );
};

export default Popup;
